module.exports = __webpack_public_path__ + "img/nasolabial_female_wide.cea360f5.png";